// Static-site email handling — opens the visitor's email client (no backend).
export const OWNER_EMAIL = "Billing@claridentrcm.com";

export function openMailto({ subject, lines = [], to = OWNER_EMAIL }) {
  const body = lines.filter(Boolean).join("\n");
  const url = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
}
